export default __webpack_public_path__ + "static/img4-e7d424319064f476c662838dc35f46f6.jpg";